import React from "react";
import { Button, LinearProgress, Skeleton, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import ListCard from "./ListCard/ListCard";
import { Box } from "@mui/system";
import { useNavigate } from "react-router-dom";
import { loadExpiredWorkshops } from "../../state/workshopSlice";
import noResultsImage from "../../images/no-results-image.png";

const WorkshopList = ({ workshops, showMore = false }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const status = useSelector((state) => state.workshops.status);

  const selectWorkshop = (id) => {
    navigate(`/view/${id}`);
  };

  return (
    <>
      <Box sx={{ height: "100%", overflowY: "auto" }}>
        {status.listLoading && (
          <>
            <LinearProgress />
            <Skeleton width="90%" animation="wave" />
            <Skeleton width="75%" animation="wave" />
            <Skeleton width="75%" animation="wave" />
            <Skeleton width="50%" animation="wave" />
            <Skeleton width="90%" animation="wave" />
            <Skeleton width="75%" animation="wave" />
            <Skeleton width="75%" animation="wave" />
            <Skeleton width="50%" animation="wave" />
          </>
        )}
        {workshops.map((workshop, index) => (
          <ListCard workshop={workshop} key={index} select={selectWorkshop} />
        ))}
        {!status.listLoading && workshops.length <= 0 && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "1rem",
              marginTop: "3rem",
            }}
          >
            <img src={noResultsImage} width="30%" />

            <Typography variant="body1" sx={{ color: "#858383" }}>
              No workshops found
            </Typography>
          </Box>
        )}
        {showMore && workshops.length > 0 && (
          <Button
            color="primary"
            sx={{ width: "100%", marginTop: "1rem" }}
            onClick={() => dispatch(loadExpiredWorkshops(true))}
          >
            Load More
          </Button>
        )}
      </Box>
    </>
  );
};

export default WorkshopList;
